import { render, staticRenderFns } from "./imgVideoCarousel.vue?vue&type=template&id=5a4cb28d"
import script from "./imgVideoCarousel.vue?vue&type=script&lang=js"
export * from "./imgVideoCarousel.vue?vue&type=script&lang=js"
import style0 from "./imgVideoCarousel.vue?vue&type=style&index=0&id=5a4cb28d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports